// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a6fdd7f0","453":"f0817b0f","732":"5c82f838","977":"0277e5c4"}[chunkId] + ".chunk.js";
};